export const COLUMN_HEADERS = {
  Duration: "Duration (days)",
};
